/**
 * @author      jordan.sookikian@zumper.com (Jordan Sookikian)
 * @copyright   Copyright (c) 2021, Zumper
 */

import { filterActions } from '@zumper/redux-ignore'

import * as constants from './constants'
import { profileReducer } from './reducers/index'

export const profile = filterActions(profileReducer, Object.values(constants))
